<template>
  <div
    class="mineAnalaze"
    ref="mainContainer"
    :class="{ 'low-perf': devicePerformance === 'low' }"
  >
    <!-- 动态背景层 -->
    <!-- <canvas ref="particleCanvas" class="particle-canvas"></canvas>
    <canvas ref="nebulaCanvas" class="nebula-canvas"></canvas>
    <div class="holographic-grid"></div> -->
    <div class="fiber-network"></div>
    <div class="announcement">
      <!-- <i @click="getinfo" class="more-info">查看更多</i> -->
      <div class="announcement-bar">
        <div class="announcement-text">
          <span>
            页面中所有外币交易金额均按每日 24:00 汇率换算为人民币合计呈现，相关数据仅供业务统计与参考使用。
          </span>
          <span class="hRight" @click="lookRate">
            查看汇率
          </span>
        </div>
        <!-- <div class="cascader-demo" v-if="childrenOrgs.length > 0 && hasPermission.includes('portal:dashboard:seeDepartStaff')" > -->
        <div class="cascader-demo" v-if="childrenOrgs.length > 0 && hasPermission.includes('portal:dashboard:seeDepartStaff')" >
                <el-cascader
                  v-model="childs"
                  :options="childrenOrgs"
                  :props="cascaderProps"
                  placeholder="请选择部门/人员"
                  collapse-tags
                  clearable
                  @change="handleChange"
                ></el-cascader>
              </div>
      </div>
    </div>
    <div class="mineContainer">
      <div class="hLeft">
        <!-- <div class="duration">数据截止至昨日</div> -->
      </div>
      <div class="hCenter">
        <!-- 优化：使用 v-once 优化静态文本 -->
        <span v-once class="title-glow">门户大数据分析</span>
      </div>
    </div>
    <div class="tabBox">
      <el-tabs  v-model="activeName" @tab-click="handleClick">
        <template v-if="isShowPart('Total')">
          <el-tab-pane label="总览" name="first" lazy>
            <div class="control">
              <div class="country">
                <!-- <div class="countrySel">地区选择</div>
                <el-select v-model="region" placeholder="请选择" style="width: 150px">
                  <el-option v-for="item in countryList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select> -->
              </div>
              <el-date-picker v-model="dateValue" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
                              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
              >
              </el-date-picker>

              <el-select v-model="category" placeholder="请选择" multiple v-collapse-tags="2">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              
              <el-button @click="handleQueryTabOne" class="magnetic-btn">查询</el-button>
            </div>
            <div class="analyzeBox">
              <!-- 总销售额 - 上方长方形，带翻牌器效果 -->
              <div class="totalSales">
                <div class="totalSalesCard flip-card">
                  <div class="flip-card-inner">
                    <div class="flip-card-front">
                      <p class="totalSalesLabel">总销售额</p>
                      <div class="flip-number-container">
                        <template v-if="formattedTotalAmount && formattedTotalAmount.length > 0">
                          <span 
                            v-for="(digit, index) in formattedTotalAmount" 
                            :key="`${index}-${digit}`"
                            class="flip-digit"
                            :class="{ 'flip-active': digit !== ' ' && digit !== '' }"
                          >
                            {{ digit }}
                          </span>
                        </template>
                        <span v-else class="flip-digit">{{ $formatNumber(displayTotalAmount || 0) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- 销售分布图表 - 左 -->
              <div class="chartWrapper salesDistribution" v-if="dataTwo">
                <EchartsTwo ref="childTwo" :dataTwo="dataTwo" :category="category"></EchartsTwo>
              </div>
              
              <!-- 设备类型 - 中 -->
              <!-- 修复：使用事件委托，在父元素上绑定事件，移除子元素的 @click -->
              <div class="typeAll" @click="handleCardClick">
                <div
                  class="deviceCard card-3d"
                  v-show="isTypeOneShow"
                  :style="getDeviceStyle(JNZamount)"
                >
                  <p class="deviceName">771/772</p>
                  <p class="number-counter">{{ $formatNumber(JNZamount) }}</p>
                </div>
                <div
                  class="deviceCard card-3d"
                  v-show="isTypeTwoShow"
                  :style="getDeviceStyle(DPamount)"
                >
                  <p class="deviceName">775</p>
                  <p class="number-counter">{{ $formatNumber(DPamount) }}</p>
                </div>
                <div
                  class="deviceCard card-3d"
                  v-show="isTypeThreeShow"
                  :style="getDeviceStyle(amount776)"
                >
                  <p class="deviceName">776</p>
                  <p class="number-counter">{{ $formatNumber(amount776) }}</p>
                </div>
                <div
                  class="deviceCard card-3d"
                  v-show="isTypeFourShow"
                  :style="getDeviceStyle(amount779)"
                >
                  <p class="deviceName">779</p>
                  <p class="number-counter">{{ $formatNumber(amount779) }}</p>
                </div>
                <div
                  class="deviceCard card-3d"
                  v-show="isTypeFiveShow"
                  :style="getDeviceStyle(amount780)"
                >
                  <p class="deviceName">780</p>
                  <p class="number-counter">{{ $formatNumber(amount780) }}</p>
                </div>
                <div
                  class="deviceCard card-3d"
                  v-show="isTypeSixShow"
                  :style="getDeviceStyle(amount781)"
                >
                  <p class="deviceName">781</p>
                  <p class="number-counter">{{ $formatNumber(amount781) }}</p>
                </div>
                <div
                  class="deviceCard card-3d"
                  v-show="isTypeSevenShow"
                  :style="getDeviceStyle(amount782)"
                >
                  <p class="deviceName">782</p>
                  <p class="number-counter">{{ $formatNumber(amount782) }}</p>
                </div>
                <div
                  class="deviceCard card-3d"
                  v-show="isTypeEightShow"
                  :style="getDeviceStyle(amount783)"
                >
                  <p class="deviceName">783</p>
                  <p class="number-counter">{{ $formatNumber(amount783) }}</p>
                </div>
              </div>
              
              <!-- 退款率图表 - 右 -->
              <div class="chartWrapper refundRate" v-if="totalNum !== 0">
                <EchartsFour ref="childFour" :refundRate="refundRate"></EchartsFour>
              </div>
            </div>

            <div class="chartBox">
              <!-- 修复：移除 v-once，图表需要响应数据变化 -->
              <EchartsOne v-if="dataOne" ref="childOne" :region="region" :dataOne="dataOne"></EchartsOne>
              <EchartsFive v-if="dataFive" ref="childFive" :region="region" :dataFive="dataFive"></EchartsFive>
            </div>
            <EchartsThree v-if="dataThree" ref="childThree" :dataThree="dataThree"></EchartsThree>
            <MonthChart ref="childMonth" :allStore="allStore" v-if="allStore"></MonthChart>
          </el-tab-pane>
        </template>

        <template v-if="isShowPart('Total_two')">
          <el-tab-pane label="数据总览" name="totalTwo" lazy>
            <OverviewTotalTwo ref="overviewTotalTwo"></OverviewTotalTwo>
          </el-tab-pane>
        </template>

        <template v-if="isShowPart('Store')">
          <el-tab-pane label="景区指标" name="second" lazy>
            <StoreQuota :allStore="allStore" v-if="allStore" ref="storeQuota" ></StoreQuota>
          </el-tab-pane>
        </template>

        <template v-if="isShowPart('Device')">
          <el-tab-pane label="设备状态" name="third" lazy>
            <DeviceNum :allStore="allStore" ref="deviceNum"></DeviceNum>
            <DeviceStatus :allStore="allStore" v-if="allStore" ref="deviceStatus"></DeviceStatus>
            <DeviceQuota :allStore="allStore" :allDevice="allDevice" v-if="allStore && allDevice" ref="deviceQuota"></DeviceQuota>
          </el-tab-pane>
        </template>
        <template v-if="isShowPart('BI')">
          <el-tab-pane label="BI分析" name="fourth" lazy>
            <Tabledata :allStore="allStore" v-if="allStore" ref="tabledata"></Tabledata>
          </el-tab-pane>
        </template>

        <template v-if="isShowPart('Goods')">
          <el-tab-pane label="款式分析" name="fifth" lazy>
            <GoodsTable ref="goodsTable"></GoodsTable>
          </el-tab-pane>
        </template>
        
        <template v-if="isShowPart('RA')">
          <el-tab-pane  label="5.0退款分析" name="sixth" lazy>
            <RefundAnalysisWrapper :allStore="allStore" v-if="allStore" ref="refundAnalysisWrapper"></RefundAnalysisWrapper>
          </el-tab-pane>
        </template>
        <template v-if="isShowPart('Operate')">
          <el-tab-pane label="经营分析" name="seventh" lazy>
            <Operate></Operate>
          </el-tab-pane>
        </template>
      </el-tabs>
    </div>
    <el-dialog
      title="全球汇率对照表"
      :visible.sync="exchangeDialogVisible"
      width="700px"
      center
    >
      <el-table :data="exchangeRate" border stripe size="medium" style="width:100%">
        <el-table-column label="货币名称" prop="currency_name" align="center" />
        <el-table-column label="货币代码" prop="currency" align="center" />
        <el-table-column label="货币符号" prop="currency_symbol" align="center" />
        <el-table-column label="时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.created_at.split(' ')[0] }}
          </template>
        </el-table-column>
        <el-table-column label="汇率" prop="rate" align="center">
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button @click="exchangeDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
import EchartsOne from './components/EchartsOne'
import EchartsTwo from './components/EchartsTwo'
import EchartsThree from './components/EchartsThree'
import EchartsFour from './components/EchartsFour'
import EchartsFive from './components/EchartsFive'
import DeviceStatus from "./components/DeviceStatus";
import DeviceNum from "./components/DeviceNum";
import MonthChart from "./components/MonthChart";
import DeviceQuota from "./components/DeviceQuota";
import DeviceTrend from "./components/DeviceTrend";
import StoreQuota from "./components/StoreQuota";
import StoreTrend from "./components/StoreTrend";
import Tabledata from "../screening/screening.vue";
import GoodsTable from "./components/GoodsTable";
import Operate from "./components/Operate";
import RefundAnalysisWrapper from "./components/RefundAnalysisWrapper.vue";
import OverviewTotalTwo from "./components/OverviewTotalTwo";
import { getBIOne, getBIRefund, getBISale, getStoreList, getDeviceList, getExchangeRate, getChildrenOrg } from "@/api/bi"
import { getYearFirstDay } from '@/utils/getYearFirstDay'
import { listToTree } from '@/utils/tree'

// 性能配置常量
const PERFORMANCE_CONFIG = {
  PARTICLE_COUNT: {
    high: 150,
    medium: 80,
    low: 30
  },
  CONNECTION_DISTANCE: {
    high: 150,
    medium: 100
  },
  RESIZE_DEBOUNCE: 300, // resize 防抖延迟（ms）
  MOUSE_THROTTLE: 16, // 鼠标事件节流延迟（ms，约 60fps）
  MEMORY_CHECK_INTERVAL: 30000, // 内存检查间隔（ms）
  MEMORY_THRESHOLD: 800, // 内存阈值（MB）
  MEMORY_GROWTH_THRESHOLD: 100, // 内存增长阈值（MB）
  ANIMATION_DURATION: 800 // 数字滚动动画时长（ms）
}

// 设备类型映射常量
const DEVICE_TYPE_MAP = {
  '1': '771/772',
  '2': '775',
  '3': '776',
  '4': '779',
  '5': '780',
  '6': '781',
  '7': '782',
  '8': '783'
}

export default {
  name: "analyze",
  data() {
    // 优化：缓存 Date 对象，避免重复创建
    const now = new Date()
    const year = now.getFullYear()
    const month = now.getMonth()
    const date = now.getDate()
    
    let start
    let end

    // 如果今天是1月1日，就获取去年整个一年的日期
    if(month === 0 && date === 1) {
      start = (year - 1) + '-01-01'
      end = (year - 1) + '-12-31'
    } else {
      if(date === 1) {
        // 如果当前是1月，上个月是上一年的12月
        const lastMonth = month === 0 ? 11 : month - 1
        const lastMonthYear = month === 0 ? year - 1 : year
        const lastDayOfLastMonth = new Date(lastMonthYear, lastMonth + 1, 0)
        end = lastDayOfLastMonth.getFullYear() + '-' + (lastDayOfLastMonth.getMonth() + 1) + '-' + lastDayOfLastMonth.getDate()
      } else {
        end = year + '-' + (month + 1) + '-' + (date - 1)
      }

      start = getYearFirstDay()
    }


    // 优化：冻结静态数据，避免 Vue 响应式处理，提升性能
    const staticCountryList = Object.freeze([
      Object.freeze({ value: '1', label: '中国大陆' }),
      Object.freeze({ value: '2', label: '中国香港' }),
      Object.freeze({ value: '3', label: '中国澳门' }),
      Object.freeze({ value: '4', label: '中国台湾' }),
      Object.freeze({ value: '5', label: '阿联酋' }),
      Object.freeze({ value: '6', label: '美国' }),
      Object.freeze({ value: '7', label: '韩国' }),
    ])
    
    const staticOptions = Object.freeze([
      Object.freeze({ value: '1', label: '771/772' }),
      Object.freeze({ value: '2', label: '775' }),
      Object.freeze({ value: '3', label: '776' }),
      Object.freeze({ value: '4', label: '779' }),
      Object.freeze({ value: '5', label: '780' }),
      Object.freeze({ value: '6', label: '781' }),
      Object.freeze({ value: '7', label: '782' }),
      Object.freeze({ value: '8', label: '783' }),
    ])
    
    // 优化：缓存日期常量，避免重复计算
    const ONE_DAY_MS = 24 * 60 * 60 * 1000
    const ONE_WEEK_MS = 7 * ONE_DAY_MS
    const ONE_MONTH_MS = 30 * ONE_DAY_MS
    const ONE_YEAR_MS = 365 * ONE_DAY_MS
    
    return {
      exchangeDialogVisible: false,
      // 全球汇率对照表
      exchangeRateList: [
        { region: '中国大陆', currency: '人民币', currencyCode: 'CNY' },
        { region: '中国香港', currency: '港币', currencyCode: 'HKD' },
        { region: '中国澳门', currency: '澳门元', currencyCode: 'MOP' },
        { region: '中国台湾', currency: '新台币', currencyCode: 'TWD' },
        { region: '阿联酋', currency: '迪拉姆', currencyCode: 'AED' },
        { region: '美国', currency: '美元', currencyCode: 'USD' },
        { region: '韩国', currency: '韩元', currencyCode: 'KRW' },
      ],
      hasCurrency: ['CNY','HKD','MOP','TWD','AED','USD','KRW'],
      exchangeRate: [],
      currentExchangeRate: '0.01',
      region: '0', // 国家
      countryList: [
        { value: '0', label: '全部' },
        { value: '1', label: '中国大陆' },
        { value: '2', label: '中国香港' },
        { value: '3', label: '中国澳门' },
        { value: '4', label: '中国台湾' },
        { value: '5', label: '阿联酋' },
        { value: '6', label: '美国' },
        { value: '7', label: '韩国' },
      ],
      allStore: null, // 全部景区
      allDevice: null, // 全部设备
      dateValue: [start, end], //
      // 修复：pickerOptions 不能冻结，因为 Element UI 可能会修改它
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const now = Date.now()
              const end = new Date(now)
              const start = new Date(now - ONE_WEEK_MS)
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const now = Date.now()
              const end = new Date(now)
              const start = new Date(now - ONE_MONTH_MS)
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一年',
            onClick(picker) {
              const now = Date.now()
              const end = new Date(now)
              const start = new Date(now - ONE_YEAR_MS)
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      category: ['1', '2','3','4','5','6','7','8'],
      options: staticOptions,
      dataOne: null, // 景区销售排名
      dataTwo: null, // 销售数据
      dataThree: null, // 设备排名
      dataFive: null, // 设备排名
      totalAmount: 0,// 总销售额（真实值）
      displayTotalAmount: 0, // 总销售额-用于前端滚动展示的数值
      DPamount: 0, // 大牌数据
      JNZamount: 0, // 纪念章数据
      amount776: 0, // 776设备
      amount779: 0, // 779设备
      amount780: 0, // 780设备
      amount781: 0, // 781设备
      amount782: 0, // 782设备
      amount783: 0, // 783设备
      totalNum: 0, // 总销售量
      refundRate: 0, // 退款率
      activeName: this.getActiveName(), // 默认展示的是哪一个页面
      isTypeOneShow: false, // 纪念章统计是否展示
      isTypeTwoShow: false, // 大牌统计是否展示
      isTypeThreeShow: false, // 776板块是否展示
      isTypeFourShow: false, // 779板块是否展示
      isTypeFiveShow: false, // 780板块是否展示
      isTypeSixShow: false, // 781板块是否展示
      isTypeSevenShow: false, // 782板块是否展示
      isTypeEightShow: false, // 783板块是否展示
      particleSystem: null, // 粒子系统
      nebulaSystem: null, // 星云系统
      mouseX: 0, // 鼠标X位置（用于粒子效果）
      mouseY: 0, // 鼠标Y位置（用于粒子效果）
      devicePerformance: 'medium', // 设备性能等级: 'high', 'medium', 'low'
      enableParticleSystem: true, // 是否启用粒子系统（由性能检测决定）
      // 动画和事件监听器引用，用于清理
      particleAnimationId: null, // 粒子动画ID
      nebulaAnimationId: null, // 星云动画ID
      particleMouseHandler: null, // 粒子鼠标移动处理器
      particleResizeHandler: null, // 粒子resize处理器
      nebulaResizeHandler: null, // 星云resize处理器
      particleVisibilityHandler: null, // 粒子可见性处理器
      nebulaVisibilityHandler: null, // 星云可见性处理器
      flipAnimationTimers: [], // 翻牌动画定时器数组
      explosionTimers: [], // 爆炸效果定时器数组
      particlesArray: null, // 粒子数组引用，用于清理
      // 内存管理
      memoryMonitorInterval: null, // 内存监控定时器
      memoryMonitorVisibilityHandler: null, // 内存监控可见性处理器
      lastMemoryUsage: 0, // 上次内存使用量
      memoryCleanupCount: 0, // 内存清理次数
      maxMemoryMB: 800, // 最大内存阈值（MB），提高阈值避免影响功能
      resizeTimer: null, // resize 防抖定时器
      // 数据缓存优化
      dataCache: new Map(), // 数据缓存 Map，key 为请求参数序列化后的字符串
      cacheExpireTime: 5 * 60 * 1000, // 缓存过期时间：5分钟
      childrenOrgs: [], // 子组织列表
      childs: [], // 选中的子组织
      cascaderProps: {
        // multiple: true,
        checkStrictly: true,
      },
      hasPermission: this.$store.getters.permissions,
      selectedNodes: [], // 选中的节点
    }
  },
  created() {

    // 获取景区列表、获取设备列表
    this.detectDevicePerformance();
    
    // 优化：并行请求，减少等待时间
    Promise.all([
      this.fetchStoreList(),
      getDeviceList().then(res => {
        if (res && res.code === 2000 && res.data) {
          this.allDevice = res.data;
        }
        return res;
      }).catch(e => {
        console.error('获取设备列表失败', e)
        return null;
      })
    ]).then(() => {
      // 所有基础数据加载完成后的回调（如果需要）
    })
    this.getChildrenOrgs()
    this.getExchangeRates()
  },
  computed: {
    // 格式化总销售额为字符数组，用于翻牌器效果
    formattedTotalAmount() {
      const formatted = this.$formatNumber(this.displayTotalAmount || 0)
      // 将格式化后的字符串转换为字符数组，每个字符一个元素
      const chars = formatted.split('')
      // 确保至少有一个字符显示
      return chars.length > 0 ? chars : ['0']
    },
    // 最大设备金额，用于归一化设备卡片的大小/亮度（优化：使用更高效的方法）
    maxDeviceAmount() {
      // 优化：避免使用扩展运算符，直接比较
      const amounts = [
        Number(this.JNZamount) || 0,
        Number(this.DPamount) || 0,
        Number(this.amount776) || 0,
        Number(this.amount779) || 0,
        Number(this.amount780) || 0,
        Number(this.amount781) || 0,
        Number(this.amount782) || 0,
        Number(this.amount783) || 0
      ]
      // 使用 reduce 比扩展运算符更高效
      return amounts.reduce((max, val) => val > max ? val : max, 0)
    },
    // 筛选图表数据，用于销售分布卡片（优化：使用 Map 缓存，减少查找次数）
    filteredChartData() {
      if (!this.dataTwo || !Array.isArray(this.dataTwo)) {
        return []
      }
      // 使用 Map 缓存，避免多次 find 操作
      const dataMap = new Map()
      this.dataTwo.forEach(item => {
        if (item && item.name) {
          dataMap.set(item.name, item)
        }
      })
      
      const filterdData = []
      // 遍历选中的分类，从 Map 中获取数据（使用配置常量）
      this.category.forEach(cat => {
        const deviceName = DEVICE_TYPE_MAP[cat]
        if (deviceName) {
          const item = dataMap.get(deviceName)
          if (item) filterdData.push(item)
        }
      })
      
      // 按值排序，从大到小（修复：创建新数组避免修改原数组）
      return [...filterdData].sort((a, b) => (b.value || 0) - (a.value || 0))
    }
  },
  watch: {
    // 监听总销售额变化，触发翻牌动画（优化：添加 immediate: false，避免初始化时触发）
    displayTotalAmount: {
      handler(newVal, oldVal) {
        // 优化：避免初始值相同时的无效触发
        if (newVal === oldVal || oldVal === undefined) {
          return
        }
        // 清理之前的定时器（修复：添加安全检查）
        if (this.flipAnimationTimers && Array.isArray(this.flipAnimationTimers)) {
          this.flipAnimationTimers.forEach(timer => clearTimeout(timer));
          this.flipAnimationTimers = [];
        }
        
        // 优化：使用 requestAnimationFrame 替代 nextTick，性能更好
        requestAnimationFrame(() => {
          const digits = document.querySelectorAll('.flip-digit.flip-active')
          digits.forEach((digit, index) => {
            const timer = setTimeout(() => {
              digit.style.animation = 'none'
              // 强制重排以重新触发动画
              void digit.offsetWidth
              digit.style.animation = 'flipNumber 0.6s ease-in-out'
            }, index * 50) // 错开动画时间，形成波浪效果
            this.flipAnimationTimers.push(timer);
          })
        })
      },
      immediate: false
    }
  },
  mounted() {
    console.log(555, this.hasPermission)
    window.addEventListener('resize',this.resizeChart)
    this.initAnimations();
    this.handleQueryTabOne();
    // 启动内存监控
    this.startMemoryMonitor();
  },
  methods: {
    getChildrenOrgs(){
      getChildrenOrg().then(res => {
        if (res && res.code === 2000 && res.data) {
          this.childrenOrgs = listToTree(res.data)
        }
      }).catch(e => {
        console.error('获取子组织失败', e)
      })
    },
    fetchStoreList() {
      return getStoreList().then(res => {
        // 接口可能返回 data: {}，必须保证 allStore 始终为数组
        if (res && res.code === 2000 && Array.isArray(res.data)) {
          this.allStore = res.data
        } else {
          this.allStore = []
        }
        return res
      }).catch(e => {
        console.error('获取景区列表失败', e)
        this.allStore = []
        return null
      })
    },
    handleChange(val) {
      console.log('选择变化：', val, this.childrenOrgs);
      // 兼容单选/多选：统一处理为二维数组格式
      const paths = Array.isArray(val) ? (Array.isArray(val[0]) ? val : [val]) : [];
      const selectedNodes = this.getSelectedNodes(paths, this.childrenOrgs);
      if (selectedNodes.length > 0) {
        this.$store.commit('user/SET_TARGET_ID', selectedNodes[0].value)
        this.selectedNodes = selectedNodes;
      } else {
        this.$store.commit('user/SET_TARGET_ID', null)
        this.selectedNodes = []
      }
      // 部门变更后，按 targetid 重新拉取景区、ERP 仓库列表，再触发各模块查询
      const storeQuota = this.$refs.storeQuota
      Promise.all([
        this.fetchStoreList(),
        storeQuota && storeQuota.loadErpStoreList
          ? storeQuota.loadErpStoreList()
          : Promise.resolve()
      ]).finally(() => {
        this.handleQueryTabOne(); // 总览的查询
        this.$refs.overviewTotalTwo && this.$refs.overviewTotalTwo.handleQuery(); // 总览2.0的查询
        storeQuota && storeQuota.handleQuery(); // 景区指标的查询
        this.$refs.deviceNum && this.$refs.deviceNum.handleQuery(); // 设备状态的查询
        this.$refs.deviceStatus && this.$refs.deviceStatus.handleQuery(); // 设备状态的查询
        this.$refs.deviceQuota && this.$refs.deviceQuota.handleQuery(); // 设备状态的查询
        this.$refs.tabledata && this.$refs.tabledata.handleQuery(); // BI分析的查询
        this.$refs.goodsTable && this.$refs.goodsTable.handleQuery(); // 款式分析的查询
        this.$refs.refundAnalysisWrapper && this.$refs.refundAnalysisWrapper.handleQuery(); // 退款分析的查询
      })
      // 启动内存监控
      console.log('选中节点详情：', selectedNodes);
    },
    getSelectedNodes(paths, tree) {
      const nodes = [];
      const findNode = (path, tree) => {
        let current = tree;
        const nodePath = [];
        for (const id of path) {
          const target = current.find(item => item.value === id);
          if (target) {
            nodePath.push(target);
            current = target.children || []; // 兼容无children的叶子节点
          } else {
            break; // 找不到节点时终止，避免报错
          }
        }
        // 取最后一个有效节点（叶子节点）
        if (nodePath.length > 0) {
          nodes.push(nodePath[nodePath.length - 1]);
        }
      };
      paths.forEach(path => findNode(path, tree));
      return nodes;
    },
    getExchangeRates(){
      getExchangeRate().then(res => {
        if (res && res.code === 2000 && res.data) {
          this.exchangeRate = res.data.filter(item => this.hasCurrency.includes(item.currency))
          this.exchangeRate.forEach(item => {
            this.exchangeRateList.forEach(key => {
              if(item.currency == key.currencyCode){
                item.currency_name = key.currency
              }
            })
          })
          console.log(777, this.exchangeRate)
        }
      }).catch(e => {
        console.error('获取汇率失败', e)
      })
    },
    // 生成缓存 key（优化：对数组进行排序，确保相同参数生成相同 key）
    getCacheKey(params) {
      // 修复：对 source 数组排序，确保相同参数（无论顺序）生成相同缓存 key
      const sortedParams = {
        ...params,
        source: params.source && Array.isArray(params.source) 
          ? [...params.source].sort() 
          : params.source
      }
      return JSON.stringify(sortedParams)
    },
    
    // 检查缓存
    getCachedData(key) {
      const cached = this.dataCache.get(key)
      if (cached && Date.now() - cached.timestamp < this.cacheExpireTime) {
        return cached.data
      }
      // 缓存过期或不存在，清理
      if (cached) {
        this.dataCache.delete(key)
      }
      return null
    },
    
    // 设置缓存
    setCachedData(key, data) {
      this.dataCache.set(key, {
        data,
        timestamp: Date.now()
      })
      // 限制缓存大小，避免内存泄漏（修复：添加安全检查）
      if (this.dataCache && this.dataCache.size > 10) {
        const firstKey = this.dataCache.keys().next().value
        if (firstKey !== undefined) {
          this.dataCache.delete(firstKey)
        }
      }
    },
    
    async handleQueryTabOne() {
      this.isShowTypePart();
      // 查询数据
      const params = {
        start: this.dateValue && this.dateValue[0] || undefined,
        end: this.dateValue && this.dateValue[1] || undefined,
        source: this.category,
        region_id: this.region * 1,
      }
      if(this.selectedNodes.length > 0) { // 这里加这个target_id是为了参数不同，避免缓存而不去掉接口
        params.targetid = this.selectedNodes[0].value;
      }
      
      // 优化：检查缓存（只缓存主数据，退款和销售数据每次都请求以确保数据最新）
      const cacheKey = this.getCacheKey(params)
      const cachedData = this.getCachedData(cacheKey)
      
      let biOneRes
      if (cachedData) {
        // 使用缓存数据
        this.processBIOneData(cachedData)
        // 即使使用缓存，也需要请求退款和销售数据
        const [biRefundRes, biSaleRes] = await Promise.allSettled([
          getBIRefund(params),
          getBISale(params)
        ])
        
        // 处理退款数据
        if (biRefundRes.status === 'fulfilled' && biRefundRes.value) {
          const res = biRefundRes.value
          if (res && res.code === 2000 && res.data) {
            const refund_num = res.data.refund_Amount
            if (!refund_num || !this.totalNum) {
              this.refundRate = 0
            } else {
              this.refundRate = String(refund_num / (this.totalNum + refund_num))
            }
          }
        }
        
        // 处理销售数据
        if (biSaleRes.status === 'fulfilled' && biSaleRes.value) {
          const res = biSaleRes.value
          if (res && res.code === 2000 && res.data) {
            this.dataThree = res.data
          }
        }
        return
      }
      
      // 优化：并行请求所有数据，而不是串行
      const [biOneResResult, biRefundRes, biSaleRes] = await Promise.allSettled([
        getBIOne(params),
        getBIRefund(params),
        getBISale(params)
      ])
      biOneRes = biOneResResult
      
      // 处理主数据
      if (biOneRes.status === 'fulfilled' && biOneRes.value) {
        const res = biOneRes.value
        this.processBIOneData(res)
        // 缓存数据
        this.setCachedData(cacheKey, res)
      } else {
        console.error('获取BI数据失败', biOneRes.reason)
        this.dataOne = null
        this.totalNum = 0
        this.dataFive = null
        this.refundRate = 0
        this.dataThree = null
        this.DPamount = 0
        this.JNZamount = 0
        this.amount776 = 0
        this.amount779 = 0
        this.amount780 = 0
        this.amount781 = 0
        this.amount782 = 0
        this.amount783 = 0
        this.dataTwo = null
        this.animateTotalAmount(0)
      }
      
      // 处理退款数据
      if (biRefundRes.status === 'fulfilled' && biRefundRes.value) {
        const res = biRefundRes.value
        if (res && res.code === 2000 && res.data) {
          const refund_num = res.data.refund_Amount; // 总退款数
          if (!refund_num || !this.totalNum) { // 分子分母任何一个为0，退款率就是0
            this.refundRate = 0;
          } else {
            this.refundRate = String(refund_num / (this.totalNum + refund_num));
          }
        }
      } else {
        console.error('获取退款数据失败', biRefundRes.reason)
      }
      
      // 处理销售数据
      if (biSaleRes.status === 'fulfilled' && biSaleRes.value) {
        const res = biSaleRes.value
        if (res && res.code === 2000 && res.data) {
          this.dataThree = res.data;
        }
      } else {
        console.error('获取销售数据失败', biSaleRes.reason)
      }
    },
    
    // 提取数据处理逻辑，便于复用和缓存
    processBIOneData(res) {
      if (res && res.code === 2000 && res.data) {
        // 修复：添加安全检查，避免空数据报错
        if (res.data.company_sort) {
          this.$store.commit('bi/SET_BI_ONE', res.data.company_sort)
          this.dataOne = this.addIndexData(res.data.company_sort); // 景区销售排名
        } else {
          this.dataOne = null
        }
        this.dataTwo = res.data.sales_volume && res.data.sales_volume.pieData; // 销售数据
        console.log('dataTwo',this.dataTwo);
        // 总销售额（带数字滚动效果）
        let newTotal = 0
        if (res.data.sales_volume && res.data.sales_volume.totalAmount !== undefined) {
          newTotal = res.data.sales_volume.totalAmount
        }
        const oldTotal = this.totalAmount || 0
        this.totalAmount = newTotal
        this.animateTotalAmount(oldTotal, newTotal)
        
        // 安全获取各个金额值（优化：使用 Map 减少重复查找）
        if (this.dataTwo && Array.isArray(this.dataTwo) && this.dataTwo.length > 0) {
          // 使用 Map 缓存，避免多次 find 操作
          const dataMap = new Map()
          this.dataTwo.forEach(item => {
            if (item && item.name) {
              dataMap.set(item.name, item)
            }
          })
          
          // 从 Map 中获取数据，性能更好
          const getValue = (name) => {
            const item = dataMap.get(name)
            return (item && item.value !== undefined) ? item.value : 0
          }
          
          this.DPamount = getValue('775')
          this.JNZamount = getValue('771/772')
          this.amount776 = getValue('776')
          this.amount779 = getValue('779')
          this.amount780 = getValue('780')
          this.amount781 = getValue('781')
          this.amount782 = getValue('782')
          this.amount783 = getValue('783')
        } else {
          this.DPamount = 0
          this.JNZamount = 0
          this.amount776 = 0
          this.amount779 = 0
          this.amount780 = 0
          this.amount781 = 0
          this.amount782 = 0
          this.amount783 = 0
        }
        
        console.log('总销售额:', this.totalAmount);
        console.log('各设备金额:', {
          DPamount: this.DPamount,
          JNZamount: this.JNZamount,
          amount776: this.amount776,
          amount779: this.amount779,
          amount780: this.amount780,
          amount781: this.amount781,
          amount782: this.amount782,
          amount783: this.amount783
        });
        
        this.totalNum = res.data.sales_volume && res.data.sales_volume.totalNum || 0; // 总销售量

        // 修复：添加安全检查，避免空数据报错
        if (res.data.device_sort) {
          this.dataFive = this.addIndexData(res.data.device_sort); // 设备销售排名
        } else {
          this.dataFive = null
        }
        // this.dataFive = res.data.device_sort; // 设备销售排名
      } else {
        this.dataOne = null
        this.totalNum = 0
        this.dataFive = null
      }
    },
    // 防抖优化的 resize 处理
    resizeChart() {
      // 清除之前的定时器
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      // 设置新的定时器，使用配置常量
      this.resizeTimer = setTimeout(() => {
        this.$refs.childOne && this.$refs.childOne.$emit('resizeOne');
        this.$refs.childTwo && this.$refs.childTwo.$emit('resizeTwo');
        this.$refs.childThree && this.$refs.childThree.$emit('resizeThree');
        this.$refs.childFour && this.$refs.childFour.$emit('resizeFour');
        this.$refs.childFive && this.$refs.childFive.$emit('resizeFive');
        this.$refs.childMonth && this.$refs.childMonth.$emit('resizeMonth');
        this.resizeTimer = null;
      }, PERFORMANCE_CONFIG.RESIZE_DEBOUNCE);
    },
    handleClick(tab) {
      if (tab && tab.name === 'totalTwo') {
        this.$nextTick(() => {
          const overview = this.$refs.overviewTotalTwo
          if (!overview) return
          if (overview.chart) {
            overview.chart.resize()
            overview.renderChart && overview.renderChart()
          } else if (overview.initChart) {
            overview.initChart()
          }
          if (overview.sourceChart) {
            overview.sourceChart.resize()
            overview.renderSourceChart && overview.renderSourceChart()
          } else if (overview.initSourceChart) {
            overview.initSourceChart()
          }
          if (overview.regionChart) {
            overview.regionChart.resize()
            overview.renderRegionChart && overview.renderRegionChart()
          } else if (overview.initRegionChart) {
            overview.initRegionChart()
          }
          if (overview.companyTypeChart) {
            overview.companyTypeChart.resize()
            overview.renderCompanyTypeChart && overview.renderCompanyTypeChart()
          } else if (overview.initCompanyTypeChart) {
            overview.initCompanyTypeChart()
          }
        })
      }
    },
    addIndexData(oldArr){ // 将景区销售排名、设备销售排名
      // 修复：添加安全检查，避免空数据报错
      if (!oldArr || !oldArr.yData || !Array.isArray(oldArr.yData)) {
        return { xData: (oldArr && oldArr.xData) || [], yData: [] }
      }
      // 创建一个新的yData数组
      // const newYData = oldArr.yData.map((value, index) => `${index + 1}.${value}`);
      const newYData = oldArr.yData.map((value, index) => `${value}`);
      // 创建一个新的对象，xData不变，yData替换为新的数组
      return  {xData: oldArr.xData, yData: newYData};
    },
    isShowPart(name){
      // 是否展示设备状态-模块 Total 看总览 Device 看设备状态 seeStore 看景区指标 seeBI 看BI分析
      const { permissions } = this.$store.getters;
      const partName = 'portal:dashboard:see' + name;
      return permissions.includes(partName);
    },
    getActiveName(){
      // 决定哪个板块才是展示的默认页面（首页-* 权限）
      const { permissions } = this.$store.getters;
      let homeName = 'first'
      if (permissions.includes('portal:dashboard:homeIsTotal')) {
        homeName = 'first'
      } else if (permissions.includes('portal:dashboard:homeIsTotal_two')) {
        homeName = 'totalTwo'
      } else if (permissions.includes('portal:dashboard:homeIsStore')) {
        homeName = 'second'
      } else if (permissions.includes('portal:dashboard:homeIsDevice')) {
        homeName = 'third'
      } else if (permissions.includes('portal:dashboard:homeIsBI')) {
        homeName = 'fourth'
      } else if (permissions.includes('portal:dashboard:seeRA')) {
        homeName = 'sixth'
      } else {
        homeName = 'first'
      }
      console.log('homeName', homeName);
      return homeName;
    },
    // 修复：移除未使用的 name 参数
    isShowTypePart(){
      // 判断是否出现
      this.isTypeOneShow = this.category.includes('1')
      this.isTypeTwoShow = this.category.includes('2')
      this.isTypeThreeShow = this.category.includes('3')
      this.isTypeFourShow = this.category.includes('4')
      this.isTypeFiveShow = this.category.includes('5')
      this.isTypeSixShow = this.category.includes('6')
      this.isTypeSevenShow = this.category.includes('7')
      this.isTypeEightShow = this.category.includes('8')
    },
    // 初始化动画系统
    initAnimations() {
      // 修复：确保在 mounted 时再检查一次，因为此时 DOM 已经准备好
      // 根据设备性能决定是否启用粒子系统
      if (this.enableParticleSystem) {
        // 使用 nextTick 确保 canvas ref 已经准备好
        this.$nextTick(() => {
          this.initParticleSystem();
        });
      }
      // 使用 nextTick 确保 canvas ref 已经准备好
      this.$nextTick(() => {
        this.initNebulaSystem();
      });
      this.initHolographicGrid();
      this.initFiberNetwork();
    },
    // 检测设备性能
    detectDevicePerformance() {
      let score = 0;
      const factors = [];
      
      // 1. 检测CPU核心数
      const cores = navigator.hardwareConcurrency || 2;
      if (cores >= 8) {
        score += 30;
        factors.push(`CPU核心数: ${cores} (优秀)`);
      } else if (cores >= 4) {
        score += 20;
        factors.push(`CPU核心数: ${cores} (良好)`);
      } else {
        score += 10;
        factors.push(`CPU核心数: ${cores} (一般)`);
      }
      
      // 2. 检测设备内存（如果支持）
      const memory = navigator.deviceMemory;
      if (memory) {
        if (memory >= 8) {
          score += 30;
          factors.push(`内存: ${memory}GB (优秀)`);
        } else if (memory >= 4) {
          score += 20;
          factors.push(`内存: ${memory}GB (良好)`);
        } else {
          score += 10;
          factors.push(`内存: ${memory}GB (一般)`);
        }
      } else {
        // 如果不支持deviceMemory，根据其他因素推断
        score += 15; // 默认中等分数
        factors.push('内存: 未知');
      }
      
      // 3. 检测屏幕分辨率
      const screenPixels = window.screen.width * window.screen.height;
      const pixelCount = screenPixels / 1000000; // 转换为百万像素
      if (pixelCount >= 8) {
        score += 20;
        factors.push(`屏幕分辨率: ${Math.round(pixelCount)}M像素 (优秀)`);
      } else if (pixelCount >= 2) {
        score += 15;
        factors.push(`屏幕分辨率: ${Math.round(pixelCount)}M像素 (良好)`);
      } else {
        score += 10;
        factors.push(`屏幕分辨率: ${Math.round(pixelCount)}M像素 (一般)`);
      }
      
      // 4. 检测是否为移动设备
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      if (isMobile) {
        score -= 20; // 移动设备性能通常较低
        factors.push('设备类型: 移动设备');
      } else {
        factors.push('设备类型: 桌面设备');
      }
      
      // 5. 检测是否使用电池（笔记本可能降频）
      if (navigator.getBattery) {
        navigator.getBattery().then(battery => {
          if (battery.charging === false && battery.level < 0.2) {
            score -= 10;
            factors.push('电池状态: 低电量（可能降频）');
          }
        }).catch(() => {
          // 忽略错误
        });
      }
      
      // 6. 检测Canvas性能（快速测试）
      try {
        const testCanvas = document.createElement('canvas');
        testCanvas.width = 100;
        testCanvas.height = 100;
        const testCtx = testCanvas.getContext('2d');
        const startTime = performance.now();
        
        // 执行一些Canvas操作
        for (let i = 0; i < 100; i++) {
          testCtx.fillRect(Math.random() * 100, Math.random() * 100, 10, 10);
        }
        
        const endTime = performance.now();
        const canvasTime = endTime - startTime;
        
        if (canvasTime < 5) {
          score += 20;
          factors.push(`Canvas性能: ${canvasTime.toFixed(2)}ms (优秀)`);
        } else if (canvasTime < 15) {
          score += 15;
          factors.push(`Canvas性能: ${canvasTime.toFixed(2)}ms (良好)`);
        } else {
          score += 10;
          factors.push(`Canvas性能: ${canvasTime.toFixed(2)}ms (一般)`);
        }
      } catch (e) {
        // 忽略错误
      }
      console.log('设备性能得分:', score, '因子:', factors);
      // 根据总分确定性能等级
      if (score >= 95) {
        this.devicePerformance = 'high';
        this.enableParticleSystem = true;
        console.log('设备性能: 高', factors);
      } else if (score >= 85) {
        this.devicePerformance = 'medium';
        this.enableParticleSystem = true;
        console.log('设备性能: 中', factors);
      } else {
        this.devicePerformance = 'low';
        this.enableParticleSystem = false;
        console.log('设备性能: 低，已禁用粒子系统', factors);
      }
    },
    // 粒子系统 - 增强版动态星空
    initParticleSystem() {
      const canvas = this.$refs.particleCanvas;
      if (!canvas) return;
      
      const ctx = canvas.getContext('2d');
      const particles = [];
      
      // 根据设备性能调整粒子数量（使用配置常量）
      const particleCount = PERFORMANCE_CONFIG.PARTICLE_COUNT[this.devicePerformance] || PERFORMANCE_CONFIG.PARTICLE_COUNT.low
      
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      
      class Particle {
        constructor() {
          this.x = Math.random() * canvas.width;
          this.y = Math.random() * canvas.height;
          this.vx = (Math.random() - 0.5) * 0.5;
          this.vy = (Math.random() - 0.5) * 0.5;
          this.radius = Math.random() * 3 + 0.5; // 随机大小
          this.opacity = Math.random() * 0.8 + 0.2; // 随机亮度
          this.twinkleSpeed = Math.random() * 0.02 + 0.01; // 闪烁速度
          this.twinklePhase = Math.random() * Math.PI * 2; // 闪烁相位
          this.mouseInfluence = 0; // 鼠标引力影响
        }
        
        update(mouseX, mouseY) {
          // 鼠标引力波扰动
          if (mouseX && mouseY) {
            const dx = mouseX - this.x;
            const dy = mouseY - this.y;
            const distance = Math.sqrt(dx * dx + dy * dy);
            const maxDistance = 200;
            
            if (distance < maxDistance) {
              const force = (maxDistance - distance) / maxDistance * 0.1;
              this.vx += (dx / distance) * force;
              this.vy += (dy / distance) * force;
            }
          }
          
          // 更新位置
          this.x += this.vx;
          this.y += this.vy;
          
          // 边界反弹
          if (this.x < 0 || this.x > canvas.width) this.vx *= -1;
          if (this.y < 0 || this.y > canvas.height) this.vy *= -1;
          
          // 速度衰减
          this.vx *= 0.99;
          this.vy *= 0.99;
          
          // 闪烁效果
          this.twinklePhase += this.twinkleSpeed;
        }
        
        draw() {
          // 闪烁亮度
          const twinkle = (Math.sin(this.twinklePhase) + 1) / 2;
          const currentOpacity = this.opacity * (0.5 + twinkle * 0.5);
          
          // 使用霓虹蓝紫色系
          const colors = [
            `rgba(0, 212, 255, ${currentOpacity})`,  // 霓虹蓝
            `rgba(139, 92, 246, ${currentOpacity})`,  // 紫色
            `rgba(6, 182, 212, ${currentOpacity})`   // 青色
          ];
          const color = colors[Math.floor(Math.random() * colors.length)];
          
          ctx.beginPath();
          ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
          
          // 添加发光效果
          ctx.shadowBlur = 10;
          ctx.shadowColor = color;
          ctx.fillStyle = color;
          ctx.fill();
          ctx.shadowBlur = 0;
        }
      }
      
      for (let i = 0; i < particleCount; i++) {
        particles.push(new Particle());
      }
      
      // 监听鼠标移动更新位置 - 保存引用以便清理（优化：添加节流）
      let lastMouseUpdate = 0
      this.particleMouseHandler = (e) => {
        const now = performance.now()
        if (now - lastMouseUpdate >= PERFORMANCE_CONFIG.MOUSE_THROTTLE) {
          this.mouseX = e.clientX
          this.mouseY = e.clientY
          lastMouseUpdate = now
        }
      }
      document.addEventListener('mousemove', this.particleMouseHandler, { passive: true })
      
      // 页面可见性检测，不可见时暂停动画
      let isPageVisible = !document.hidden;
      this.particleVisibilityHandler = () => {
        isPageVisible = !document.hidden;
        if (!isPageVisible && this.particleAnimationId) {
          cancelAnimationFrame(this.particleAnimationId);
          this.particleAnimationId = null;
        }
      };
      document.addEventListener('visibilitychange', this.particleVisibilityHandler);
      
      // 保存particles数组引用，用于清理
      this.particlesArray = particles;
      
      const animate = () => {
        // 如果页面不可见，停止动画
        if (!isPageVisible || document.hidden) {
          this.particleAnimationId = null;
          return;
        }
        
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        particles.forEach(particle => {
          particle.update(this.mouseX, this.mouseY);
          particle.draw();
        });
        
        // 根据设备性能决定是否绘制连线（优化：使用距离平方避免开方运算，使用配置常量）
        const maxDistance = PERFORMANCE_CONFIG.CONNECTION_DISTANCE[this.devicePerformance]
        if (maxDistance) {
          const maxDistSq = maxDistance * maxDistance // 使用距离平方，避免开方运算
          const opacityBase = this.devicePerformance === 'high' ? 0.3 : 0.2
          
          particles.forEach((p1, i) => {
            particles.slice(i + 1).forEach(p2 => {
              const dx = p1.x - p2.x
              const dy = p1.y - p2.y
              const distSq = dx * dx + dy * dy // 距离平方
              
              if (distSq < maxDistSq) {
                const distance = Math.sqrt(distSq) // 只在需要时计算开方
                const opacity = opacityBase * (1 - distance / maxDistance)
                ctx.beginPath()
                
                if (this.devicePerformance === 'high') {
                  // 高性能设备：使用渐变
                  const gradient = ctx.createLinearGradient(p1.x, p1.y, p2.x, p2.y)
                  gradient.addColorStop(0, `rgba(0, 212, 255, ${opacity})`)
                  gradient.addColorStop(0.5, `rgba(139, 92, 246, ${opacity})`)
                  gradient.addColorStop(1, `rgba(6, 182, 212, ${opacity})`)
                  ctx.strokeStyle = gradient
                } else {
                  // 中等性能设备：使用简单颜色
                  ctx.strokeStyle = `rgba(0, 212, 255, ${opacity})`
                }
                
                ctx.lineWidth = 0.5
                ctx.moveTo(p1.x, p1.y)
                ctx.lineTo(p2.x, p2.y)
                ctx.stroke()
              }
            })
          })
        }
        // 低性能设备：不绘制连线，只显示粒子
        
        this.particleAnimationId = requestAnimationFrame(animate);
      };
      
      this.particleAnimationId = requestAnimationFrame(animate);
      
      // 保存resize处理器引用以便清理
      this.particleResizeHandler = () => {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
      };
      window.addEventListener('resize', this.particleResizeHandler);
    },
    // 星云流动效果
    initNebulaSystem() {
      const canvas = this.$refs.nebulaCanvas;
      if (!canvas) return;
      
      const ctx = canvas.getContext('2d');
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      
      let time = 0;
      let isPageVisible = !document.hidden;
      
      // 页面可见性检测
      this.nebulaVisibilityHandler = () => {
        isPageVisible = !document.hidden;
        if (!isPageVisible && this.nebulaAnimationId) {
          cancelAnimationFrame(this.nebulaAnimationId);
          this.nebulaAnimationId = null;
        }
      };
      document.addEventListener('visibilitychange', this.nebulaVisibilityHandler);
      
      const animate = () => {
        // 如果页面不可见，停止动画
        if (!isPageVisible || document.hidden) {
          this.nebulaAnimationId = null;
          return;
        }
        
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        time += 0.01;
        
        const gradient = ctx.createRadialGradient(
          canvas.width / 2 + Math.sin(time) * 100,
          canvas.height / 2 + Math.cos(time) * 100,
          0,
          canvas.width / 2,
          canvas.height / 2,
          canvas.width
        );
        
        gradient.addColorStop(0, 'rgba(0, 212, 255, 0.15)');
        gradient.addColorStop(0.3, 'rgba(139, 92, 246, 0.1)');
        gradient.addColorStop(0.6, 'rgba(6, 182, 212, 0.08)');
        gradient.addColorStop(1, 'rgba(10, 14, 39, 0)');
        
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        
        this.nebulaAnimationId = requestAnimationFrame(animate);
      };
      
      this.nebulaAnimationId = requestAnimationFrame(animate);
      
      // 保存resize处理器引用以便清理
      this.nebulaResizeHandler = () => {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
      };
      window.addEventListener('resize', this.nebulaResizeHandler);
    },
    // 全息投影网格
    initHolographicGrid() {
      // CSS动画处理
    },
    // 光纤网络连线
    initFiberNetwork() {
      // CSS动画处理
    },
    // 优化：使用事件委托，减少事件监听器数量
    handleCardClick(e) {
      // 事件委托：检查点击的是否是卡片
      const card = e.target.closest('.deviceCard')
      if (!card) return
      
      // 粒子爆炸效果
      const rect = card.getBoundingClientRect();
      const x = rect.left + rect.width / 2;
      const y = rect.top + rect.height / 2;
      
      // 优化：使用 DocumentFragment 批量添加 DOM，减少重排
      const fragment = document.createDocumentFragment();
      const particles = [];
      
      // 创建爆炸粒子
      for (let i = 0; i < 20; i++) {
        const particle = document.createElement('div');
        particle.className = 'explosion-particle';
        particle.style.left = x + 'px';
        particle.style.top = y + 'px';
        particle.style.setProperty('--angle', (Math.PI * 2 * i / 20) + 'rad');
        fragment.appendChild(particle);
        particles.push(particle);
      }
      
      document.body.appendChild(fragment);
      
      // 优化：使用 requestAnimationFrame 优化清理时机
      requestAnimationFrame(() => {
        particles.forEach(particle => {
          setTimeout(() => {
            if (particle.parentNode) {
              particle.remove();
            }
          }, 1000);
        });
      });
      
      // 波纹扩散
      const ripple = document.createElement('div');
      ripple.className = 'ripple-effect';
      ripple.style.left = x + 'px';
      ripple.style.top = y + 'px';
      document.body.appendChild(ripple);
      
      setTimeout(() => {
        if (ripple.parentNode) {
          ripple.remove();
        }
      }, 600);
    },
    // 总销售额数字滚动动画
    animateTotalAmount(from, to) {
      const start = Number(from) || 0
      const end = Number(to) || 0
      if (start === end) {
        this.displayTotalAmount = end
        return
      }
      const duration = PERFORMANCE_CONFIG.ANIMATION_DURATION // 使用配置常量
      const startTime = performance.now()

      const easeOutQuad = (t) => 1 - (1 - t) * (1 - t)

      const step = (now) => {
        const elapsed = now - startTime
        const progress = Math.min(1, elapsed / duration)
        const eased = easeOutQuad(progress)
        this.displayTotalAmount = start + (end - start) * eased
        if (progress < 1) {
          requestAnimationFrame(step)
        } else {
          this.displayTotalAmount = end
        }
      }

      requestAnimationFrame(step)
    },
    // 计算占比，保留两位小数；极小正数不低于 0.01%
    getPercent(value, total) {
      if (!value || !total || total === 0) {
        return '0.00'
      }
      const percent = (value / total) * 100
      if (percent > 0 && percent < 0.01) {
        return '0.01'
      }
      return percent.toFixed(2)
    },
    // 根据金额大小计算设备卡片的“亮度”（不再放大尺寸，彻底避免重叠）
    getDeviceStyle(amount) {
      const value = Number(amount) || 0
      const max = this.maxDeviceAmount || 0
      if (!max) {
        return {
          opacity: 0.85
        }
      }
      const ratio = Math.max(0, Math.min(1, value / max))
      const opacity = 0.75 + 0.25 * ratio // 0.75 ~ 1
      return {
        opacity
      }
    },
    lookRate() {
      this.exchangeDialogVisible = true
    },
    // 启动内存监控
    startMemoryMonitor() {
      // 使用配置常量设置检查间隔
      this.memoryMonitorInterval = setInterval(() => {
        this.checkAndCleanMemory();
      }, PERFORMANCE_CONFIG.MEMORY_CHECK_INTERVAL);
      
      // 页面不可见时暂停监控 - 保存引用以便清理
      this.memoryMonitorVisibilityHandler = () => {
        if (document.hidden) {
          this.stopMemoryMonitor();
        } else {
          if (!this.memoryMonitorInterval) {
            this.startMemoryMonitor();
          }
        }
      };
      document.addEventListener('visibilitychange', this.memoryMonitorVisibilityHandler);
    },
    
    // 停止内存监控
    stopMemoryMonitor() {
      if (this.memoryMonitorInterval) {
        clearInterval(this.memoryMonitorInterval);
        this.memoryMonitorInterval = null;
      }
      // 清理可见性监听器
      if (this.memoryMonitorVisibilityHandler) {
        document.removeEventListener('visibilitychange', this.memoryMonitorVisibilityHandler);
        this.memoryMonitorVisibilityHandler = null;
      }
    },
    
    // 检查并清理内存
    checkAndCleanMemory() {
      try {
        // 检查内存使用（如果浏览器支持）
        if (performance.memory) {
          const usedMB = performance.memory.usedJSHeapSize / 1024 / 1024;
          const totalMB = performance.memory.totalJSHeapSize / 1024 / 1024;
          
          // 如果内存增长超过阈值，执行清理（使用配置常量）
          if (usedMB > PERFORMANCE_CONFIG.MEMORY_THRESHOLD || 
              (this.lastMemoryUsage > 0 && usedMB - this.lastMemoryUsage > PERFORMANCE_CONFIG.MEMORY_GROWTH_THRESHOLD)) {
            console.warn(`内存使用过高: ${usedMB.toFixed(2)}MB / ${totalMB.toFixed(2)}MB，执行清理...`);
            this.performMemoryCleanup();
            this.lastMemoryUsage = usedMB;
          } else {
            this.lastMemoryUsage = usedMB;
          }
        }
      } catch (e) {
        // 忽略错误
      }
    },
    
    // 执行内存清理
    performMemoryCleanup() {
      this.memoryCleanupCount++;
      
      // 1. 清理所有定时器（修复：添加安全检查）
      if (this.flipAnimationTimers && Array.isArray(this.flipAnimationTimers)) {
        this.flipAnimationTimers.forEach(timer => clearTimeout(timer));
        this.flipAnimationTimers = [];
      }
      if (this.explosionTimers && Array.isArray(this.explosionTimers)) {
        this.explosionTimers.forEach(timer => clearTimeout(timer));
        this.explosionTimers = [];
      }
      
      // 2. 清理粒子数组（仅在内存压力极大时减少粒子，不影响功能）
      // 注意：减少粒子数量会影响视觉效果，但不会影响业务功能
      if (this.particlesArray && this.particlesArray.length > 0) {
        // 只在内存清理超过5次时才减少粒子（说明内存压力非常大）
        if (this.memoryCleanupCount > 5) {
          const keepCount = Math.floor(this.particlesArray.length * 0.7);
          this.particlesArray.splice(keepCount);
        }
      }
      
      // 3. 清理Canvas缓存
      const particleCanvas = this.$refs.particleCanvas;
      if (particleCanvas) {
        const ctx = particleCanvas.getContext('2d');
        if (ctx) {
          // 强制清理Canvas
          ctx.clearRect(0, 0, particleCanvas.width, particleCanvas.height);
          // 重新设置大小以释放内存
          const w = particleCanvas.width;
          const h = particleCanvas.height;
          particleCanvas.width = 1;
          particleCanvas.height = 1;
          particleCanvas.width = w;
          particleCanvas.height = h;
        }
      }
      
      // 4. 不清理数据对象（保留完整数据以支持所有功能）
      // 数据清理只在页面销毁时进行，不影响功能使用
      
      // 5. 强制垃圾回收提示
      if (window.gc) {
        try {
          window.gc();
        } catch (e) {
          // 忽略错误
        }
      }
      
      console.log(`内存清理完成 (第${this.memoryCleanupCount}次)`);
    },
    
    // 强制清理所有引用
    forceCleanup() {
      // 清空所有数组
      this.flipAnimationTimers = null;
      this.explosionTimers = null;
      this.particlesArray = null;
      
      // 清空所有对象引用
      Object.keys(this).forEach(key => {
        if (key.startsWith('particle') || key.startsWith('nebula') || key.startsWith('data')) {
          try {
            this[key] = null;
          } catch (e) {
            // 忽略错误
          }
        }
      });
    }
  },
  components: {
    EchartsOne,
    EchartsTwo,
    EchartsThree,
    EchartsFour,
    EchartsFive,
    DeviceStatus,
    DeviceNum,
    MonthChart,
    DeviceQuota,
    DeviceTrend,
    StoreQuota,
    StoreTrend,
    Tabledata,
    GoodsTable,
    Operate,
    RefundAnalysisWrapper,
    OverviewTotalTwo
  },

  beforeDestroy() {
    // 离开页面必须进行移除，否则会造成内存泄漏，导致卡顿
    window.removeEventListener('resize', this.resizeChart);
    
    // 清理 resize 防抖定时器
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = null;
    }
    
    // 1. 清理所有动画帧
    if (this.particleAnimationId) {
      cancelAnimationFrame(this.particleAnimationId);
      this.particleAnimationId = null;
    }
    if (this.nebulaAnimationId) {
      cancelAnimationFrame(this.nebulaAnimationId);
      this.nebulaAnimationId = null;
    }
    
    // 2. 清理事件监听器
    if (this.particleMouseHandler) {
      document.removeEventListener('mousemove', this.particleMouseHandler);
      this.particleMouseHandler = null;
    }
    if (this.particleVisibilityHandler) {
      document.removeEventListener('visibilitychange', this.particleVisibilityHandler);
      this.particleVisibilityHandler = null;
    }
    if (this.nebulaVisibilityHandler) {
      document.removeEventListener('visibilitychange', this.nebulaVisibilityHandler);
      this.nebulaVisibilityHandler = null;
    }
    if (this.particleResizeHandler) {
      window.removeEventListener('resize', this.particleResizeHandler);
      this.particleResizeHandler = null;
    }
    if (this.nebulaResizeHandler) {
      window.removeEventListener('resize', this.nebulaResizeHandler);
      this.nebulaResizeHandler = null;
    }
    
    // 清理所有定时器（修复：添加安全检查）
    if (this.flipAnimationTimers && Array.isArray(this.flipAnimationTimers)) {
      this.flipAnimationTimers.forEach(timer => clearTimeout(timer));
      this.flipAnimationTimers = [];
    }
    if (this.explosionTimers && Array.isArray(this.explosionTimers)) {
      this.explosionTimers.forEach(timer => clearTimeout(timer));
      this.explosionTimers = [];
    }
    
    // 3. 清理Canvas上下文，释放内存
    const particleCanvas = this.$refs.particleCanvas;
    if (particleCanvas) {
      const ctx = particleCanvas.getContext('2d');
      if (ctx) {
        ctx.clearRect(0, 0, particleCanvas.width, particleCanvas.height);
        particleCanvas.width = 0;
        particleCanvas.height = 0;
      }
    }
    
    const nebulaCanvas = this.$refs.nebulaCanvas;
    if (nebulaCanvas) {
      const ctx = nebulaCanvas.getContext('2d');
      if (ctx) {
        ctx.clearRect(0, 0, nebulaCanvas.width, nebulaCanvas.height);
        nebulaCanvas.width = 0;
        nebulaCanvas.height = 0;
      }
    }
    
    // 4. 清空所有大型数据对象，释放内存
    this.dataOne = null;
    this.dataTwo = null;
    this.dataThree = null;
    this.dataFive = null;
    this.allStore = null;
    this.allDevice = null;
    this.particleSystem = null;
    this.nebulaSystem = null;
    // 清空粒子数组，释放闭包引用
    if (this.particlesArray) {
      this.particlesArray.length = 0;
      this.particlesArray = null;
    }
    // 清空数据缓存
    if (this.dataCache) {
      this.dataCache.clear();
      this.dataCache = null;
    }
    
    // 5. 清理Vuex store中的数据
    if (this.$store && this.$store.commit) {
      try {
        this.$store.commit('bi/SET_BI_ONE', null);
      } catch (e) {
        // 忽略错误
      }
    }
    
    // 6. 清理所有ECharts实例
    try {
      const chartRefs = ['childOne', 'childTwo', 'childThree', 'childFour', 'childFive', 'childMonth'];
      chartRefs.forEach(ref => {
        if (this.$refs[ref] && this.$refs[ref].chart) {
          this.$refs[ref].chart.dispose();
          this.$refs[ref].chart = null;
        }
      });
    } catch (e) {
      console.warn('清理ECharts实例时出错:', e);
    }
    
    // 7. 停止内存监控
    this.stopMemoryMonitor();
    
    // 8. 强制清理所有引用
    this.forceCleanup();
  }
}
</script>

<style lang="scss" scoped>
.mineAnalaze {
  max-width: 1920px;
  min-width: 1024px;
  background: linear-gradient(135deg, #0a0e27 0%, #1a1b3e 25%, #2d1b4e 50%, #1a1b3e 75%, #0a0e27 100%) !important;
  position: relative;
  overflow: hidden;
  min-height: 100vh;
}

/* 动态背景层 */
.particle-canvas,
.nebula-canvas {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
  /* 优化：提示浏览器优化动画性能 */
  will-change: transform, opacity;
}

.particle-canvas {
  z-index: 2;
}

.nebula-canvas {
  z-index: 1;
}

/* 全息投影网格 */
.holographic-grid {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    linear-gradient(rgba(0, 212, 255, 0.15) 1px, transparent 1px),
    linear-gradient(90deg, rgba(139, 92, 246, 0.15) 1px, transparent 1px);
  background-size: 50px 50px;
  pointer-events: none;
  z-index: 1;
  animation: gridMove 20s linear infinite;
  opacity: 0.4;
}

@keyframes gridMove {
  0% { transform: translate(0, 0); }
  100% { transform: translate(50px, 50px); }
}

/* 光纤网络连线 */
.fiber-network {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
  background: 
    radial-gradient(circle at 20% 30%, rgba(0, 212, 255, 0.2) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(139, 92, 246, 0.2) 0%, transparent 50%),
    radial-gradient(circle at 50% 50%, rgba(6, 182, 212, 0.15) 0%, transparent 50%);
  animation: fiberPulse 4s ease-in-out infinite;
}

@keyframes fiberPulse {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 0.8; }
}

/* 低性能设备自动降级：关闭大面积持续动画，减轻 GPU 压力 */
.mineAnalaze.low-perf .holographic-grid,
.mineAnalaze.low-perf .fiber-network {
  animation: none !important;
  opacity: 0.2;
}

.mineAnalaze.low-perf .title-glow,
.mineAnalaze.low-perf .number-counter,
.mineAnalaze.low-perf .pulse-glow,
.mineAnalaze.low-perf .card-3d::before {
  animation: none !important;
}

/* 遵循系统“减少动态效果”设置，自动降级动画 */
@media (prefers-reduced-motion: reduce) {
  .mineAnalaze .holographic-grid,
  .mineAnalaze .fiber-network,
  .mineAnalaze .title-glow,
  .mineAnalaze .number-counter,
  .mineAnalaze .pulse-glow,
  .mineAnalaze .card-3d::before {
    animation: none !important;
  }
}


/* 标题发光效果 */
.title-glow {
  position: relative;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: titlePulse 3s ease-in-out infinite;
  color: #00d4ff;
  text-shadow: 
    0 0 10px rgba(0, 212, 255, 0.9),
    0 0 20px rgba(139, 92, 246, 0.7),
    0 0 30px rgba(6, 182, 212, 0.5),
    0 0 40px rgba(0, 212, 255, 0.3);
}

@keyframes titlePulse {
  0%, 100% { 
    text-shadow: 
      0 0 10px rgba(0, 212, 255, 0.9),
      0 0 20px rgba(139, 92, 246, 0.7),
      0 0 30px rgba(6, 182, 212, 0.5);
  }
  50% { 
    text-shadow: 
      0 0 20px rgba(0, 212, 255, 1),
      0 0 40px rgba(139, 92, 246, 0.9),
      0 0 60px rgba(6, 182, 212, 0.7),
      0 0 80px rgba(236, 72, 153, 0.5);
  }
}

/* 磁吸按钮效果 */
.magnetic-btn {
  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  position: relative;
  overflow: hidden;
}

.magnetic-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.magnetic-btn:hover::before {
  width: 300px;
  height: 300px;
}

.magnetic-btn:active {
  transform: scale(0.95);
}

/* 数字滚动特效 */
.number-counter {
  font-weight: bold;
  background: linear-gradient(90deg, #fff 0%, #00d4ff 25%, #8b5cf6 50%, #06b6d4 75%, #fff 100%);
  background-size: 200% 100%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: numberShine 3s linear infinite;
}

@keyframes numberShine {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

/* 脉冲发光效果 */
.pulse-glow {
  animation: pulseGlow 2s ease-in-out infinite;
  position: relative;
}

.pulse-glow::after {
  content: '';
  position: absolute;
  top: -5px;
  left: -5px;
  right: -5px;
  bottom: -5px;
  border-radius: 50%;
  border: 2px solid rgba(0, 212, 255, 0.6);
  animation: pulseRing 2s ease-out infinite;
}

@keyframes pulseGlow {
  0%, 100% { 
    box-shadow: 
      0 0 20px rgba(0, 212, 255, 0.6),
      0 0 30px rgba(139, 92, 246, 0.4);
  }
  50% { 
    box-shadow: 
      0 0 40px rgba(0, 212, 255, 0.9),
      0 0 60px rgba(139, 92, 246, 0.7),
      0 0 80px rgba(6, 182, 212, 0.5);
  }
}

@keyframes pulseRing {
  0% { transform: scale(1); opacity: 1; }
  100% { transform: scale(1.5); opacity: 0; }
}

/* 3D翻转卡片 - 全息投影效果 */
.card-3d {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  transform-style: preserve-3d;
  cursor: pointer;
  position: relative;
  backdrop-filter: blur(10px);
  background: rgba(0, 212, 255, 0.05);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 12px;
  overflow: hidden;
  /* 优化：提示浏览器优化变换性能 */
  will-change: transform, box-shadow;
}

/* 四角扫描点 */
.card-3d::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: 
    radial-gradient(circle at 0 0, rgba(0, 212, 255, 0.6) 3px, transparent 3px),
    radial-gradient(circle at 100% 0, rgba(139, 92, 246, 0.6) 3px, transparent 3px),
    radial-gradient(circle at 0 100%, rgba(6, 182, 212, 0.6) 3px, transparent 3px),
    radial-gradient(circle at 100% 100%, rgba(236, 72, 153, 0.6) 3px, transparent 3px);
  background-size: 30px 30px;
  background-position: 0 0, 100% 0, 0 100%, 100% 100%;
  animation: scanPoints 3s linear infinite;
  pointer-events: none;
  z-index: 1;
}

@keyframes scanPoints {
  0%, 100% { opacity: 0.3; }
  50% { opacity: 1; }
}

.card-3d:hover {
  transform: translateY(-10px) rotateX(5deg) rotateY(5deg);
  box-shadow: 
    0 20px 40px rgba(0, 212, 255, 0.5),
    0 0 60px rgba(139, 92, 246, 0.3),
    inset 0 0 30px rgba(0, 212, 255, 0.1);
  border-color: rgba(0, 212, 255, 0.6);
}

.card-3d:active {
  transform: translateY(-5px) rotateX(2deg) rotateY(2deg) scale(0.98);
}

.card-3d > * {
  position: relative;
  z-index: 2;
}

/* 波纹扩散效果 */
.ripple-effect {
  position: fixed;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(0, 212, 255, 0.7), rgba(139, 92, 246, 0.5));
  transform: translate(-50%, -50%);
  animation: ripple 0.6s ease-out;
  pointer-events: none;
  z-index: 9998;
}

@keyframes ripple {
  0% {
    width: 10px;
    height: 10px;
    opacity: 1;
  }
  100% {
    width: 300px;
    height: 300px;
    opacity: 0;
  }
}

/* 粒子爆炸效果 */
.explosion-particle {
  position: fixed;
  width: 4px;
  height: 4px;
  background: radial-gradient(circle, rgba(0, 212, 255, 1), rgba(139, 92, 246, 0.8));
  border-radius: 50%;
  pointer-events: none;
  z-index: 9997;
  animation: explode 1s ease-out forwards;
  box-shadow: 0 0 10px rgba(0, 212, 255, 0.8);
}

@keyframes explode {
  0% {
    transform: translate(0, 0) scale(1);
    opacity: 1;
  }
  100% {
    transform: translate(
      calc(cos(var(--angle)) * 100px),
      calc(sin(var(--angle)) * 100px)
    ) scale(0);
    opacity: 0;
  }
}

.mineContainer {
  position: relative;
  z-index: 10;
  height: 72px;
}


.announcement {
  width: 100%;
  height: 42px;
  line-height: 40px;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;
}

.more-info {
  position: absolute;
  right: 15px;
  color: #ffffff;
  cursor: pointer;
  z-index: 10;
}

.announcement-bar {
  /* width: calc(100% - 100px); */
  width: 100%;
  color: white;
  text-align: center;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  .cascader-demo{
    ::v-deep .el-cascader {
      width: 250px;
      background: linear-gradient(135deg, rgba(0, 212, 255, 0.15), rgba(139, 92, 246, 0.15)) !important;
      border: 1px solid rgba(0, 212, 255, 0.3) !important;
      border-radius: 20px !important;
      height: 40px !important;
      line-height: 40px !important;
      padding: 0 16px !important;
      box-shadow: 0 0 8px rgba(0, 212, 255, 0.2) !important;
      transition: all 0.3s ease !important;

      &:hover {
        border-color: rgba(0, 212, 255, 0.6) !important;
        box-shadow: 0 0 12px rgba(0, 212, 255, 0.3) !important;
      }

      &.is-focus {
        border-color: #00d4ff !important;
        box-shadow: 0 0 16px rgba(0, 212, 255, 0.4) !important;
      }
      .el-input{
        text-align: left;
      }
    }

    /* 输入框文字样式 */
    ::v-deep .el-input__inner {
      color: #ffffff !important;
      font-size: 16px !important;
      font-weight: 500 !important;
      background: transparent !important;
      border: none !important;
      height: 40px !important;
      line-height: 40px !important;
      padding: 0 !important;
      max-width: 230px;
      &::placeholder {
        color: rgba(255, 255, 255, 0.6) !important;
      }
    }

    /* 下拉箭头样式 */
    ::v-deep .el-input__suffix {
      color: #00d4ff !important;
      right: 0px !important;
      top: 50% !important;
      transform: translateY(-50%) !important;
    }

    /* 清空按钮样式 */
    ::v-deep .el-input__clear {
      color: rgba(255, 255, 255, 0.7) !important;
      &:hover {
        color: #ffffff !important;
      }
    }

    /* 折叠标签样式（多选时） */
    ::v-deep .el-tag {
      background: rgba(0, 212, 255, 0.2) !important;
      border: 1px solid rgba(0, 212, 255, 0.4) !important;
      color: #ffffff !important;
      border-radius: 12px !important;
      height: 24px !important;
      line-height: 22px !important;
      margin: 4px 4px !important;
    }

    /* 下拉面板样式 */
    ::v-deep .el-cascader-panel {
      background: linear-gradient(135deg, #0a192f, #1a1a2e) !important;
      border: 1px solid rgba(0, 212, 255, 0.3) !important;
      border-radius: 8px !important;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5) !important;
      color: #ffffff !important;
    }

    /* 节点文字样式 */
    ::v-deep .el-cascader-panel .el-cascader-node__label {
      padding-left: 0 !important;
      color: #ffffff !important;
      font-size: 14px !important;
    }

    /* 节点hover/选中样式 */
    ::v-deep .el-cascader-panel .el-cascader-node.is-hovered {
      background: rgba(0, 212, 255, 0.15) !important;
    }
    ::v-deep .el-cascader-panel .el-cascader-node.is-active {
      background: rgba(0, 212, 255, 0.25) !important;
      color: #00d4ff !important;
      font-weight: 500 !important;
    }

    /* 优化节点内边距，提升点击体验 */
    ::v-deep .el-cascader-panel .el-cascader-node {
      padding: 8px 12px !important;
      height: auto !important;
      line-height: 1.5 !important;
    }

    /* 修复展开箭头位置，避免错位 */
    ::v-deep .el-cascader-panel .el-cascader-node__arrow {
      right: 0px !important;
      color: rgba(0, 212, 255, 0.7) !important;
    }

    /* 隐藏多选框（原需求保留） */
    ::v-deep .el-cascader-panel .el-checkbox {
      display: none !important;
    }
    ::v-deep .el-cascader__tags {
      flex-wrap: nowrap;
      .el-tag{
        max-width: 75%;
      }
    }
  }
}

.announcement-text {
  display: inline-block;
  white-space: nowrap;
  text-align: center;
  background: linear-gradient(135deg, rgba(0, 212, 255, 0.15), rgba(139, 92, 246, 0.15));
  border-radius: 20px;
  padding: 0 20px;
  /* display: flex; */
  /* animation:  20s linear infinite; */
}

@keyframes scroll {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}


.hLeft {
  width: 25%;
  color: #00d4ff;
}
.hRight {
  /* margin-top: -20px; */
  margin-left: 20px;
  color: #00d4ff;
  /* text-align: right; */
  text-decoration: underline;
  cursor: pointer;
}

.hCenter {
  width: 50%;
  text-align: center;

}

.hCenter span {
  font-size: 30px;
}

.today {
  display: flex;
  justify-content: space-around;
  width: 50%;
  margin: -10px auto 10px auto;
}

/*.duration {*/
/*  text-align: center;*/
/*}*/

.rightBox {
  display: flex;
  justify-content: space-around;
}

.rightBox p {
  border: 1px solid rgba(0, 212, 255, 0.6);
  padding: 10px 40px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 0 10px rgba(0, 212, 255, 0.3);
}

.rightBox p:hover {
  border-color: rgba(0, 212, 255, 1);
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.6), 0 0 30px rgba(139, 92, 246, 0.4);
}

.control {
  width: 700px;
  margin: 20px auto;
  padding: 20px;
  border-radius: 30px;
  background: rgba(0, 212, 255, 0.15);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(139, 92, 246, 0.3);
  box-shadow: 0 8px 32px rgba(0, 212, 255, 0.1);
  display: flex;
  justify-content: space-between;

}

.country{
  display: flex;
  align-items: center;
  height: 42px;
}
.countrySel{
  margin-right: 10px;
  color: #FFF;
}


.analyzeBox {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto auto;
  column-gap: 35px;
  row-gap: 25px;
  width: 90%;
  max-width: 1600px;
  margin: 0 auto 40px auto;
  align-items: start;
  padding: 15px 0;
  position: relative;
}

/* 总销售额 - 上方长方形，缩短约20%，居中显示 */
.analyzeBox > .totalSales {
  grid-column: 1 / span 3;
  grid-row: 1;
  width: 100%;
  margin-bottom: 0;
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 总销售额卡片 - 长方形样式，宽度约51.43%（从60%再缩短1/7） */
.totalSalesCard.flip-card {
  width: 51.43%;
  max-width: 51.43%;
  height: 120px;
  margin: 0 auto;
  background: linear-gradient(135deg, rgba(0, 212, 255, 0.15), rgba(139, 92, 246, 0.15));
  border: 1.5px solid rgba(0, 212, 255, 0.4);
  border-radius: 15px;
  padding: 20px 40px;
  box-shadow: 
    0 8px 32px rgba(0, 212, 255, 0.2),
    0 0 40px rgba(139, 92, 246, 0.15),
    inset 0 0 20px rgba(0, 212, 255, 0.1);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
}

.flip-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.3), transparent);
  animation: shimmer 3s infinite;
}

@keyframes shimmer {
  0% { left: -100%; }
  100% { left: 100%; }
}

.flip-card-inner {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flip-card-front {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.totalSalesLabel {
  font-size: 28px;
  font-weight: 600;
  color: #00d4ff;
  text-shadow: 
    0 0 10px rgba(0, 212, 255, 0.8),
    0 0 20px rgba(0, 212, 255, 0.5);
  margin: 0;
  flex-shrink: 0;
}

.flip-number-container {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
  justify-content: flex-end;
  font-family: 'Courier New', monospace;
}

.flip-digit {
  display: inline-block;
  font-size: 36px;
  font-weight: bold;
  color: #ffffff;
  text-shadow: 
    0 0 10px rgba(0, 212, 255, 0.9),
    0 0 20px rgba(56, 189, 248, 0.7);
  min-width: 24px;
  text-align: center;
  transition: transform 0.3s ease;
  position: relative;
  /* 优化：提示浏览器优化动画性能 */
  will-change: transform, opacity;
}

.flip-digit.flip-active {
  animation: flipNumber 0.6s ease-in-out;
}

@keyframes flipNumber {
  0% {
    transform: rotateX(0deg);
  }
  50% {
    transform: rotateX(90deg);
    opacity: 0.3;
  }
  100% {
    transform: rotateX(0deg);
    opacity: 1;
  }
}

/* 销售分布 - 左 */
.analyzeBox > .chartWrapper.salesDistribution {
  grid-column: 1;
  grid-row: 2;
  align-self: start;
  position: relative;
  z-index: 1;
}

/* 设备类型 - 中 */
.analyzeBox > .typeAll {
  grid-column: 2;
  grid-row: 2;
  align-self: start;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 12px;
  padding: 0;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 100%;
  position: relative;
  z-index: 1;
}

/* 退款率 - 右 */
.analyzeBox > .chartWrapper.refundRate {
  grid-column: 3;
  grid-row: 2;
  align-self: start;
  position: relative;
  z-index: 1;
}

/* 图表容器样式 - 无卡片形式 */
.chartWrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 200px;
  box-sizing: border-box;
  justify-content: center;
}

/* 优化图表组件内部样式 */
.chartWrapper :deep(.outBox) {
  width: 100%;
  height: 100%;
}

.chartWrapper :deep(.box) {
  width: 100%;
  height: 100%;
  min-height: 170px;
}

.chartWrapper :deep(.chart-container) {
  width: 100%;
  height: 100%;
}

.chartWrapper :deep(.mine) {
  width: 100%;
  height: 100%;
}

/* 设备类型 - 两行方块布局（已在上面定义，这里删除重复） */

/* 统一的设备类型卡片样式 - 方块形式 */
.deviceCard {
  width: 100%;
  height: 100%;
  min-height: 90px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(0, 212, 255, 0.08);
  border: 1.5px solid rgba(0, 212, 255, 0.3);
  border-radius: 10px;
  padding: 12px 10px;
  transition: all 0.3s ease;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 212, 255, 0.12);
  cursor: pointer;
  position: relative;
}

/* 前3个卡片在第一行 */
.deviceCard:nth-child(1),
.deviceCard:nth-child(2),
.deviceCard:nth-child(3) {
  grid-row: 1;
}

/* 第1、2个卡片 */
.deviceCard:nth-child(1) {
  grid-column: 1;
}

.deviceCard:nth-child(2) {
  grid-column: 2;
}

.deviceCard:nth-child(3) {
  grid-column: 3;
}

/* 后2个卡片在第二行，居中显示 */
.deviceCard:nth-child(4),
.deviceCard:nth-child(5) {
  grid-row: 2;
}

.deviceCard:nth-child(4) {
  grid-column: 1;
}

.deviceCard:nth-child(5) {
  grid-column: 2;
}


.deviceCard::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: 
    radial-gradient(circle at 0 0, rgba(0, 212, 255, 0.6) 3px, transparent 3px),
    radial-gradient(circle at 100% 0, rgba(139, 92, 246, 0.6) 3px, transparent 3px),
    radial-gradient(circle at 0 100%, rgba(6, 182, 212, 0.6) 3px, transparent 3px),
    radial-gradient(circle at 100% 100%, rgba(236, 72, 153, 0.6) 3px, transparent 3px);
  background-size: 30px 30px;
  background-position: 0 0, 100% 0, 0 100%, 100% 100%;
  animation: scanPoints 3s linear infinite;
  pointer-events: none;
  z-index: 1;
  opacity: 0.6;
}

.deviceCard:hover {
  transform: translateY(-4px);
  border-color: rgba(0, 212, 255, 0.6);
  box-shadow: 
    0 12px 40px rgba(0, 212, 255, 0.4),
    0 0 60px rgba(139, 92, 246, 0.3),
    inset 0 0 30px rgba(0, 212, 255, 0.1);
  z-index: 10;
}

.deviceCard:hover::before {
  opacity: 1;
}

.deviceCard > * {
  position: relative;
  z-index: 2;
}


.deviceCard:hover {
  z-index: 10;
}

.deviceName {
  font-size: 16px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 10px;
  text-shadow: 0 0 8px rgba(0, 212, 255, 0.5);
  text-align: center;
  line-height: 1.3;
}

.deviceCard .number-counter {
  font-size: 18px;
  font-weight: bold;
  margin-top: 0;
  text-align: center;
  line-height: 1.4;
  word-break: break-all;
}
/*.analyzeLeft,*/
/*.analyzeRight,*/
/*.analyzeCenter {*/
/*  height: 700px;*/
/*  width: 33%;*/
/*  !*background: url("../../assets/analyze/border.png");*!*/
/*  !*background-size: 100% 100%;*!*/
/*  !*border: 1px solid #8c939d;*!*/
/*}*/

/*.centerBox {*/
/*  height: 200px;*/
/*}*/

/*.centerOne {*/
/*  display: flex;*/
/*  justify-content: space-between;*/
/*}*/

.centerOne>div {
  flex:0 0 25%;
}

/* 旧的圆形样式已废弃，新样式在 .analyzeBox > .totalSales 中定义 */
/* 保留旧样式以防其他地方使用，但会被新样式覆盖 */

.circle {
  width: 200px;
  margin: 0 auto;
  height: 200px;
  border-radius: 50%;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 20px;
  background-image: url("../../assets/analyze/bg3.png");
  background-size: 100% auto;
  position: relative;
  overflow: visible;
  flex-shrink: 0;
}

.circle::before {
  content: '';
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  border-radius: 50%;
  border: 2px solid rgba(0, 212, 255, 0.4);
  animation: circleRotate 10s linear infinite;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.3);
}

@keyframes circleRotate {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/*.centerTwo {*/
/*  display: flex;*/
/*  justify-content: space-around;*/
/*  color: #ffffff;*/
/*  !*margin-top: -50px;*!*/
/*}*/





.el-button:hover {
  color: #ffffff;
  background: linear-gradient(135deg, rgba(0, 212, 255, 0.8), rgba(139, 92, 246, 0.8));
  border-color: rgba(0, 212, 255, 0.8);
  box-shadow: 
    0 0 20px rgba(0, 212, 255, 0.6),
    0 0 40px rgba(139, 92, 246, 0.4);
  transform: translateY(-2px);
}

.el-button:active {
  transform: translateY(0);
  box-shadow: 0 0 15px rgba(0, 212, 255, 0.5);
}

@media (max-width: 1400px){


  .chartBox>div {
    width: 80%;
    margin: 0 auto;
  }
}


@media (max-width: 1600px) {
  /* 小屏幕下改为单列布局 */
  .analyzeBox {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto auto;
    column-gap: 20px;
    row-gap: 25px;
  }

  /* 总销售额 - 第一行，小屏幕下全宽 */
  .analyzeBox > .totalSales {
    grid-column: 1;
    grid-row: 1;
    width: 100%;
  }

  .totalSalesCard.flip-card {
    height: 100px;
    padding: 15px 30px;
  }

  .totalSalesLabel {
    font-size: 24px;
  }

  .flip-digit {
    font-size: 30px;
    min-width: 20px;
  }

  /* 销售分布 - 第二行 */
  .analyzeBox > .chartWrapper.salesDistribution {
    grid-column: 1;
    grid-row: 2;
  }

  /* 设备类型 - 第三行 */
  .analyzeBox > .typeAll {
    grid-column: 1;
    grid-row: 3;
    align-self: stretch;
    width: 100%;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
  }

  /* 退款率 - 第四行 */
  .analyzeBox > .chartWrapper.refundRate {
    grid-column: 1;
    grid-row: 4;
  }

  /* 所有组件在小屏幕下统一高度 */
  .chartWrapper {
    height: 200px;
  }

  .analyzeBox .typeAll {
    gap: 10px;
    padding: 0;
  }

  .deviceCard {
    min-height: 75px;
    padding: 10px 8px;
  }

  .deviceName {
    font-size: 14px;
    margin-bottom: 6px;
  }

  .deviceCard .number-counter {
    font-size: 16px;
  }

  .deviceName {
    font-size: 13px;
    margin-bottom: 6px;
  }

  .deviceCard .number-counter {
    font-size: 16px;
  }

  /* 图表卡片在小屏幕上的调整 */
  .chartCard {
    padding: 15px;
  }

  .chartCardTitle {
    font-size: 14px;
  }

  .dataItem {
    padding: 8px;
  }

  .dataItemLabel {
    font-size: 12px;
  }

  .dataItemValue {
    font-size: 14px;
  }

  .dataItemPercent {
    font-size: 11px;
    padding: 3px 6px;
  }

  .refundRateValue {
    font-size: 28px;
  }

  .refundRateLabel {
    font-size: 12px;
  }

  .circle {
    width: 180px;
    height: 180px;
  }
}



@media (min-width: 1400px){
  .chartBox {
    display: flex;
    justify-content: space-between;
  }

  .chartBox>div {
    width: 45%;
  }
}



</style>

<style>
.mineAnalaze .el-range-editor.el-input__inner,
.mineAnalaze .el-range-separator,
.mineAnalaze .el-input--suffix .el-input__inner,
.mineAnalaze .el-range-input {
  background: transparent;
  color: #ffffff !important;
}

.mineAnalaze .el-select {
  width: 180px;
}

.mineAnalaze .el-select.collapse-tags-select {
  width: 280px;
}

.mineAnalaze .el-button {
  border-radius: 20px;
  background: rgba(0, 212, 255, 0.2);
  border: 1px solid rgba(0, 212, 255, 0.5);
  color: #ffffff;
  height: 40px;
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
}

.mineAnalaze .el-button:hover {
  background: linear-gradient(135deg, rgba(0, 212, 255, 0.4), rgba(139, 92, 246, 0.4));
  border-color: rgba(0, 212, 255, 0.8);
  box-shadow: 
    0 0 20px rgba(0, 212, 255, 0.6),
    0 0 40px rgba(139, 92, 246, 0.4);
}

 .mineAnalaze .el-select__input {
   color: #ffffff
 }

.mineAnalaze .longSelect.el-select {
  width: 280px;
}

.tabBox .el-tabs__nav {
  padding-bottom: 10px;
}

.tabBox .el-tabs__header {
  display: flex;
  justify-content: center;
}

.tabBox .el-tabs__item{
  color: #ffffff;
  font-size: 20px;
  padding: 5px 30px;
}

.tabBox .el-tabs__item.is-active{
  color: #00d4ff;
  position: relative;
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.8);
}

.tabBox .el-tabs__item.is-active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  height: 3px;
  background: linear-gradient(90deg, transparent, #00d4ff, #8b5cf6, transparent);
  animation: tabGlow 2s ease-in-out infinite;
  box-shadow: 0 0 10px rgba(0, 212, 255, 0.8);
}

.mineAnalaze .el-dialog__footer .el-button {
  border-radius: 6px;
  font-size: 14px;
  padding: 6px 18px;
  transition: all 0.3s ease;
}
/* 关闭按钮 */
.mineAnalaze .el-dialog__footer .el-button {
  background: transparent;
  color: rgb(0, 147, 237);
  border: 1px solid rgba(0, 212, 255, 0.4);
}
.mineAnalaze .el-dialog__footer .el-button:hover {
  color: #ffffff;
  border-color: #00d4ff;
  background: rgb(0, 147, 237);
  box-shadow: 0 0 8px rgba(0, 212, 255, 0.4);
}

@keyframes tabGlow {
  0%, 100% { 
    opacity: 0.6;
    box-shadow: 0 0 10px rgba(0, 212, 255, 0.6);
  }
  50% { 
    opacity: 1;
    box-shadow: 0 0 20px rgba(0, 212, 255, 1), 0 0 30px rgba(139, 92, 246, 0.8);
  }
}

.tabBox .el-tabs__item {
  transition: all 0.3s ease;
  position: relative;
}

.tabBox .el-tabs__item:hover {
  color: rgba(0, 212, 255, 0.9);
  transform: translateY(-2px);
  text-shadow: 0 0 8px rgba(0, 212, 255, 0.6);
}

.tabBox .el-tabs__nav-wrap::after {
  display: none;
}

</style>